import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';
import { AppConstants } from 'src/app/config.service';
import { finalize } from 'rxjs/operators';
import { ExceptionHandlingService } from 'src/app/shared/exception-handling.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService, IMyOptions } from 'ng-uikit-pro-standard';
import * as moment from 'moment';

@Component({
  selector: 'mark-tested-modal',
  templateUrl: './mark-tested.component.html',
  styleUrls: ['./mark-tested.component.scss']
})

export class MarkTestedModalComponent implements OnInit {

  @Input() selection: any;
  @Output() emitSuccess = new EventEmitter<any>();
  error: any = {}

  constructor(
    private service: SharedService,
    private appConstants: AppConstants,
    private errorService: ExceptionHandlingService,
    private toastr: ToastService,
    private translate: TranslateService
  ) { }

  ngOnInit() { }

  public datePickerOptions: IMyOptions = {
    dateFormat: 'mmm-dd-yyyy',
    closeAfterSelect: true,
    editableDateField: false
  };

  @ViewChild('markTestCompleteModal', { static: true }) markTestCompleteModal: any;

  action: any = {};
  emailSelectionType: string;

  ngOnChanges() {
    if (this.selection && this.selection.id) {
      this.action = {};
      this.uploadedFiles = [];

      this.action.dateTestCompleted = moment(new Date()).format('MMM-DD-YYYY');
      this.getQueryComponents()
      this.markTestCompleteModal.show();
    }
  }

  components: Array<any> = [];
  loader = false;
  getQueryComponents() {
    this.components = [];
    this.loader = true;
    this.service.post(this.appConstants.endPoints.certificatesEndPoint + 'critical-components/query-components', {}, {
      "ids": this.selection.components,
      "isPaging": false
    })
      .pipe(finalize(() => {
        this.loader = false;
      }))
      .subscribe(data => {
        const components = data && data.searchResults ? data.searchResults : [];
        this.components = components.map(res => {
          if (res.quantityText * 1 != res.totalComponentsReceived) {
            res['isSelected'] = true;
            res['componentsReceived'] = (res.quantityText * 1);
          }
          return res
        })
      }, res => {
        this.errorService.errorHandling(res).then(res => {
          this.error = res;
        });
      });
  }

  selectedComponent: any = {};
  confirmMarkTestComplete() {

    const url = this.appConstants.endPoints.certificatesEndPoint + 'critical-components/mark-tested';
    const criticalComponentIds = [];
    this.components.map((comp) => {
      if (comp.isSelected)
        criticalComponentIds.push({ id: comp.id })
    })

    const completedDate = moment(this.action.dateTestCompleted, 'MMM-DD-YYYY').format('MM/DD/YYYY HH:mm')
    let modelSchema = {
      "dateTestCompleted": moment(new Date(completedDate)).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
      "testStatus": this.action.testStatus,
      "criticalComponentIds": criticalComponentIds
    }

    let formData = new FormData();
    formData.append('putData', JSON.stringify(modelSchema));
    this.uploadedFiles.forEach(element => {
      formData.append('fileUpload', element);
    });

    this.loader = true;
    this.service.put(url, {}, formData).pipe(finalize(() => {
      this.loader = false;
    }))
      .subscribe(data => {
        this.markTestCompleteModal.hide();
        this.emitSuccess.emit()
        this.toastr.success(this.translate.instant('administration_componentsMarkedTestCompleteSuccessfully_label'), this.translate.instant('administration_confirmation_label'));
      },
        error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        })

  }


  uploadedFiles: any = []
  uploadFile(event, ev?) {
    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      element['id'] = Date.now() + Math.random()
      this.uploadedFiles.push(element)
    }
    if (ev && ev.target)
      ev.target.value = null
  }

  checkedState() {
    let val = false;
    val = this.components.some(res => res.isSelected == true)
    return val;
  }
}